import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelText as _vModelText, vModelSelect as _vModelSelect, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "order-detail" }
const _hoisted_2 = { class: "order-detail__shell" }
const _hoisted_3 = { class: "order-detail__crumb" }
const _hoisted_4 = {
  key: 0,
  class: "order-detail__loading"
}
const _hoisted_5 = {
  key: 1,
  class: "order-detail__loading"
}
const _hoisted_6 = {
  key: 2,
  class: "order-detail__layout"
}
const _hoisted_7 = { class: "order-detail__main" }
const _hoisted_8 = { class: "order-detail__status-icon" }
const _hoisted_9 = { class: "order-detail__status-body" }
const _hoisted_10 = { class: "order-detail__status-label" }
const _hoisted_11 = { class: "order-detail__status-desc" }
const _hoisted_12 = {
  key: 1,
  class: "order-detail__expire-note"
}
const _hoisted_13 = { class: "order-detail__status-meta" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 0,
  class: "order-detail__pay"
}
const _hoisted_16 = { class: "order-detail__pay-head" }
const _hoisted_17 = { class: "order-detail__pay-note" }
const _hoisted_18 = {
  key: 0,
  class: "order-detail__pay-note is-test"
}
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 1,
  class: "order-detail__pay-note"
}
const _hoisted_21 = {
  key: 1,
  class: "order-detail__card order-detail__timeline no-print",
  "aria-label": "주문 진행 상태"
}
const _hoisted_22 = { class: "order-detail__steps" }
const _hoisted_23 = { class: "order-detail__step-dot" }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "order-detail__step-label" }
const _hoisted_26 = { class: "order-detail__timeline-note" }
const _hoisted_27 = { class: "order-detail__card" }
const _hoisted_28 = { class: "order-detail__items" }
const _hoisted_29 = ["src", "alt"]
const _hoisted_30 = {
  key: 1,
  class: "order-detail__noimg"
}
const _hoisted_31 = { class: "order-detail__item-body" }
const _hoisted_32 = { class: "order-detail__item-name" }
const _hoisted_33 = { class: "order-detail__item-sub" }
const _hoisted_34 = {
  key: 0,
  class: "order-detail__item-policy"
}
const _hoisted_35 = { class: "order-detail__item-right" }
const _hoisted_36 = ["disabled", "onClick"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["onClick"]
const _hoisted_39 = ["onClick"]
const _hoisted_40 = {
  key: 5,
  class: "order-detail__claim-reason"
}
const _hoisted_41 = {
  key: 7,
  class: "order-detail__claim-reason"
}
const _hoisted_42 = {
  key: 8,
  class: "order-detail__claim-reason"
}
const _hoisted_43 = {
  key: 9,
  class: "order-detail__claim-reason"
}
const _hoisted_44 = {
  key: 10,
  class: "order-detail__claim-reason"
}
const _hoisted_45 = { class: "order-detail__panel-head" }
const _hoisted_46 = {
  key: 0,
  class: "order-detail__cause"
}
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { class: "order-detail__field" }
const _hoisted_49 = {
  key: 1,
  class: "order-detail__field-grid"
}
const _hoisted_50 = { class: "order-detail__field" }
const _hoisted_51 = ["value"]
const _hoisted_52 = { class: "order-detail__field" }
const _hoisted_53 = { class: "order-detail__field" }
const _hoisted_54 = ["placeholder"]
const _hoisted_55 = {
  key: 0,
  class: "order-detail__field-hint"
}
const _hoisted_56 = { class: "order-detail__panel-note" }
const _hoisted_57 = { class: "order-detail__claim-form-actions" }
const _hoisted_58 = ["disabled"]
const _hoisted_59 = {
  key: 3,
  class: "order-detail__refund-card is-need"
}
const _hoisted_60 = ["onClick"]
const _hoisted_61 = { class: "order-detail__panel-head" }
const _hoisted_62 = { class: "order-detail__field-grid" }
const _hoisted_63 = { class: "order-detail__field" }
const _hoisted_64 = ["value"]
const _hoisted_65 = { class: "order-detail__field" }
const _hoisted_66 = { class: "order-detail__field" }
const _hoisted_67 = ["placeholder"]
const _hoisted_68 = {
  key: 0,
  class: "order-detail__field-hint"
}
const _hoisted_69 = { class: "order-detail__claim-form-actions" }
const _hoisted_70 = ["disabled"]
const _hoisted_71 = { class: "order-detail__refund-badge" }
const _hoisted_72 = { key: 0 }
const _hoisted_73 = { class: "order-detail__amount" }
const _hoisted_74 = { key: 0 }
const _hoisted_75 = { key: 1 }
const _hoisted_76 = {
  key: 2,
  class: "is-total"
}
const _hoisted_77 = { class: "order-detail__card" }
const _hoisted_78 = { class: "order-detail__ship" }
const _hoisted_79 = { key: 0 }
const _hoisted_80 = {
  key: 2,
  class: "order-detail__card"
}
const _hoisted_81 = { class: "order-detail__dl" }
const _hoisted_82 = { key: 0 }
const _hoisted_83 = { key: 1 }
const _hoisted_84 = { key: 2 }
const _hoisted_85 = { key: 3 }
const _hoisted_86 = ["href"]
const _hoisted_87 = {
  key: 0,
  class: "order-detail__tax-hint"
}
const _hoisted_88 = {
  key: 1,
  class: "order-detail__tax-hint"
}
const _hoisted_89 = {
  key: 0,
  class: "order-detail__tax-reject"
}
const _hoisted_90 = ["disabled"]
const _hoisted_91 = { class: "order-detail__side no-print" }
const _hoisted_92 = { class: "order-detail__account-title" }
const _hoisted_93 = { class: "order-detail__account-amount" }
const _hoisted_94 = { class: "order-detail__account-notice" }
const _hoisted_95 = ["disabled"]
const _hoisted_96 = { class: "order-detail__account-amount" }
const _hoisted_97 = { class: "order-detail__account-meta is-open" }
const _hoisted_98 = {
  key: 0,
  class: "order-detail__account-notice"
}
const _hoisted_99 = ["disabled"]
const _hoisted_100 = { class: "order-detail__account-notice" }
const _hoisted_101 = { class: "order-detail__account-done" }
const _hoisted_102 = { class: "order-detail__account-amount is-paid" }
const _hoisted_103 = { class: "order-detail__account-notice" }
const _hoisted_104 = {
  key: 0,
  class: "order-detail__account-notice"
}
const _hoisted_105 = { class: "order-detail__remote" }
const _hoisted_106 = ["disabled"]
const _hoisted_107 = ["disabled"]
const _hoisted_108 = {
  key: 3,
  class: "order-detail__statement",
  "aria-hidden": "true"
}
const _hoisted_109 = { class: "order-detail__statement-head" }
const _hoisted_110 = { class: "order-detail__statement-meta" }
const _hoisted_111 = { class: "order-detail__statement-meta" }
const _hoisted_112 = { class: "order-detail__statement-meta" }
const _hoisted_113 = { class: "order-detail__statement-stamp" }
const _hoisted_114 = { class: "order-detail__statement-table" }
const _hoisted_115 = { key: 0 }
const _hoisted_116 = { key: 1 }
const _hoisted_117 = { key: 2 }
const _hoisted_118 = { key: 3 }
const _hoisted_119 = { key: 4 }
const _hoisted_120 = { class: "is-num" }
const _hoisted_121 = { class: "is-num" }
const _hoisted_122 = { class: "is-num" }
const _hoisted_123 = { class: "order-detail__statement-totals" }
const _hoisted_124 = { key: 0 }
const _hoisted_125 = { key: 1 }
const _hoisted_126 = {
  key: 2,
  class: "is-total"
}
const _hoisted_127 = { class: "order-detail__statement-block" }
const _hoisted_128 = {
  key: 0,
  class: "order-detail__statement-block"
}
const _hoisted_129 = { class: "order-detail__statement-note" }

import { computed, nextTick, onMounted, onUnmounted, reactive, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import AppIcon from '@/components/common/AppIcon.vue'
import MallShipmentLedger from '@/components/mall/MallShipmentLedger.vue'
import MallPayHold from '@/components/mall/MallPayHold.vue'
import MallTrackingModal from '@/components/mall/MallTrackingModal.vue'
import TaxInvoiceRequestPanel from '@/components/mall/TaxInvoiceRequestPanel.vue'
import { MALL_BANKS } from '@/constants/banks'
import { MALL_ORDERS_PATH } from '@/constants/mall'
import { formatPrice } from '@/constants/mallProducts'
import { formatShippingFeeAmount } from '@/utils/mallShipping'
import { type ShipmentLedgerRow } from '@/utils/mallShipment'
import { formatBizNumber } from '@/utils/bizNumber'
import {
  MALL_ORDER_ITEM_STATUS_LABEL,
  mallBuyerOrderStatusLabel,
  mallOrderRefundTotals,
  MALL_REFUND_STATUS_LABEL,
  cancelMyOrder,
  confirmOrderItemPurchase,
  fetchMyOrder,
  fetchTossAccess,
  notifyMyPayment,
  requestMyTaxInvoice,
  requestOrderItemClaim,
  updateOrderItemRefundAccount,
  type ClaimType,
  type MallOrder,
  type MallOrderItem,
  type MallOrderItemStatus,
  type MallPaymentInfo,
} from '@/api/mallOrder'
import { useTossPayment } from '@/composables/useTossPayment'
import { useCart } from '@/composables/useCart'
import { useMemberAuth } from '@/composables/useMemberAuth'
import {
  PENDING_EXPIRE_DAYS,
  autoConfirmLabel,
  pendingExpireLabel,
  pendingExpireTone,
} from '@/utils/mallOpsUx'
import { confirmDialog } from '@/composables/useConfirmDialog'
import { useMallToast } from '@/composables/useMallToast'
import { copyToClipboard } from '@/utils/clipboard'

const STATEMENT_PRINT_BODY_CLASS = 'is-mall-statement-print'

const REFUND_ACCOUNT_KEY = 'hamuri.mall.lastRefundAccount'


export default /*@__PURE__*/_defineComponent({
  __name: 'MallOrderDetailPage',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const { addItem } = useCart()
const { member } = useMemberAuth()
const { showSuccess, showError } = useMallToast()
const {
  ready: tossReady,
  testMode: tossTestMode,
  mount: mountToss,
  pay: requestTossPay,
} = useTossPayment()
const tossPaying = ref(false)
const tossEnabled = ref(false)
const tossMountFailed = ref(false)
const payHold = ref(route.query.pay === 'closed')

const payButtonLabel = computed(() => {
  if (tossPaying.value) return '결제창 여는 중…'
  if (tossReady.value) return '결제하기'
  if (tossMountFailed.value) return '새로고침'
  return '결제창 준비 중…'
})

const payButtonDisabled = computed(
  () => tossPaying.value || (!tossReady.value && !tossMountFailed.value),
)

const payNotice = computed(() => {
  if (!tossEnabled.value || tossMountFailed.value) {
    return '결제창을 불러오지 못했습니다. 새로고침하면 다시 결제할 수 있습니다.'
  }
  if (!tossReady.value) return '결제창을 불러오는 중입니다.'
  return '카드, 간편결제, 휴대폰결제를 받습니다. 계좌이체·가상계좌를 고르면 그 결제는 취소됩니다.'
})

function onPrint() {
  if (!canPrintStatement.value) return
  document.body.classList.add(STATEMENT_PRINT_BODY_CLASS)
  const cleanup = () => {
    document.body.classList.remove(STATEMENT_PRINT_BODY_CLASS)
    window.removeEventListener('afterprint', cleanup)
  }
  window.addEventListener('afterprint', cleanup)
  window.print()
  window.setTimeout(cleanup, 1500)
}

const code = computed(() => String(route.params.code ?? ''))

function refreshPay() {
  window.location.assign(`/mall/orders/${code.value}`)
}

function closePayHold() {
  payHold.value = false
  if (route.query.pay == null) return
  const nextQuery = { ...route.query }
  delete nextQuery.pay
  router.replace({ query: nextQuery })
}
const order = ref<MallOrder | null>(null)
const payment = ref<MallPaymentInfo | null>(null)
const loading = ref(true)
const canceling = ref(false)
const notifying = ref(false)
const reordering = ref(false)
const claiming = ref(0)
const confirming = ref(0)
const refundSaving = ref(0)
const taxRequesting = ref(false)
const copiedField = ref<'account' | 'amount' | 'depositor' | ''>('')
const refundForm = reactive({ idx: 0, bank: '', account: '', holder: '' })
const taxForm = reactive({ bizName: '', bizNum: '', email: '' })
const taxPanelRef = ref<InstanceType<typeof TaxInvoiceRequestPanel> | null>(null)
const trackTarget = ref<{
  idx: number
  courier?: string
  invoice?: string
  name?: string
  orderCode?: string
} | null>(null)

function openTracking(item: MallOrderItem) {
  trackTarget.value = item
}

function openItemShipment(item: MallOrderItem, row: ShipmentLedgerRow) {
  trackTarget.value = {
    idx: item.idx,
    courier: row.courier,
    invoice: row.invoice,
    name: item.name,
    orderCode: order.value?.code,
  }
}

function onCloseTracking() {
  trackTarget.value = null
  void load()
}

function taxStatusOf(o: MallOrder) {
  return o.taxStatus || (o.taxInvoice ? 'REQUESTED' : 'NONE')
}

const currentTaxStatus = computed(() =>
  order.value ? taxStatusOf(order.value) : 'NONE',
)

/** 입금 확인 후에만 진행단계·송장·클레임 등 이행 UI를 연다 */
const showFulfillment = computed(() => order.value?.status === 'PAID')

const refundRelation = computed(() => {
  const current = order.value
  const totals = mallOrderRefundTotals(current?.items || [])
  const charged = Math.max(0, Number(current?.totalAmount) || 0)
  return {
    ...totals,
    balance: Math.max(0, charged - totals.refunded),
  }
})

const chargeAmountLabel = computed(() => {
  if (order.value?.status === 'PENDING') {
    return order.value.payMethod === 'TOSS' ? '결제할 금액' : '입금할 금액'
  }
  return refundRelation.value.refunded ? '결제 금액' : '합계'
})

/** 거래명세서는 입금 확인된 주문만 출력한다 */
const canPrintStatement = computed(() => order.value?.status === 'PAID')

const hasTaxRecord = computed(() => {
  const status = currentTaxStatus.value
  return status === 'REQUESTED' || status === 'DONE' || Boolean(order.value?.taxInvoice)
})

/** 입금 확인된 주문만 새로 세금계산서를 요청할 수 있다 */
const canRequestTax = computed(
  () =>
    Boolean(order.value) &&
    order.value!.payMethod !== 'TOSS' &&
    order.value!.status === 'PAID' &&
    currentTaxStatus.value === 'NONE',
)

const showTaxCard = computed(() => hasTaxRecord.value || canRequestTax.value)

const taxStatusLabel = computed(() => {
  if (currentTaxStatus.value === 'DONE') return '발행 완료'
  if (currentTaxStatus.value === 'REQUESTED') return '발행 요청'
  return '미요청'
})

function fillTaxFormFromMember() {
  if (!taxForm.bizName) taxForm.bizName = member.value?.orgName || ''
  if (!taxForm.bizNum) taxForm.bizNum = member.value?.bizNum || ''
  if (!taxForm.email) taxForm.email = member.value?.bossEmail || ''
}
const claimForm = reactive<{
  idx: number
  type: ClaimType
  reason: string
  returnCause: '' | 'CHANGE' | 'FAULT'
  faultOnly: boolean
  refundBank: string
  refundAccount: string
  refundHolder: string
}>({
  idx: 0,
  type: 'CANCEL',
  reason: '',
  returnCause: '',
  faultOnly: false,
  refundBank: '',
  refundAccount: '',
  refundHolder: '',
})

const canSubmitClaim = computed(() => {
  if (!claimForm.reason) return false
  if (claimForm.type === 'RETURN' && !claimForm.returnCause) return false
  if (order.value?.payMethod === 'TOSS') return true
  return Boolean(claimForm.refundBank && claimForm.refundAccount && claimForm.refundHolder)
})

function claimRefundPreview(item: MallOrderItem) {
  if (claimForm.type === 'RETURN') {
    if (claimForm.returnCause !== 'CHANGE') return item.amount
    const fee = Math.max(0, Number(item.returnFee) || 0)
    return Math.max(0, item.amount - fee)
  }
  const items = order.value?.items || []
  const openSameSeller = items.filter(
    (row) => row.sellerCode === item.sellerCode && row.status !== 'CANCELED',
  )
  if (openSameSeller.length !== 1 || openSameSeller[0].idx !== item.idx) return item.amount
  const sellerShip = items
    .filter((row) => row.sellerCode === item.sellerCode)
    .reduce((sum, row) => sum + Math.max(0, Number(row.shippingShare) || 0), 0)
  if (sellerShip > 0) return item.amount + sellerShip
  const openAll = items.filter((row) => row.status !== 'CANCELED')
  if (openAll.length === 1) return item.amount + Math.max(0, Number(order.value?.shippingFee) || 0)
  return item.amount
}

/** 입금확인·출고준비까지 환불신청 가능. 배송 시작 뒤에는 반품만 가능하다. */
function canClaimRefund(status: MallOrderItemStatus) {
  return order.value?.status === 'PAID' && (status === 'PAID' || status === 'READY')
}

function canClaimReturn(status: MallOrderItemStatus) {
  return order.value?.status === 'PAID' && status === 'DELIVERED'
}

function canClaimFault(status: MallOrderItemStatus) {
  return order.value?.status === 'PAID' && status === 'DONE'
}

function canConfirm(status: MallOrderItemStatus) {
  return order.value?.status === 'PAID' && status === 'DELIVERED'
}

function canReview(item: MallOrderItem) {
  if (!item.productCode || !item.productCode.startsWith('MP')) return false
  return (
    order.value?.status === 'PAID' &&
    ['PAID', 'READY', 'SHIPPING', 'DELIVERED', 'DONE'].includes(item.status)
  )
}

function loadLastRefundAccount() {
  try {
    const raw = localStorage.getItem(REFUND_ACCOUNT_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as {
      bank?: string
      account?: string
      holder?: string
    }
    if (!parsed?.bank || !parsed?.account || !parsed?.holder) return null
    return {
      bank: String(parsed.bank),
      account: String(parsed.account),
      holder: String(parsed.holder),
    }
  } catch {
    return null
  }
}

function saveLastRefundAccount(bank: string, account: string, holder: string) {
  try {
    localStorage.setItem(
      REFUND_ACCOUNT_KEY,
      JSON.stringify({ bank, account, holder }),
    )
  } catch {
    /* ignore */
  }
}

function preferRefundAccount() {
  const fromMember = member.value
  if (fromMember?.refundBank && fromMember.refundAccount && fromMember.refundHolder) {
    return {
      bank: fromMember.refundBank,
      account: fromMember.refundAccount,
      holder: fromMember.refundHolder,
    }
  }
  const fromOrder = (order.value?.items || []).find(
    (item) => item.refundBank && item.refundAccount && item.refundHolder,
  )
  if (fromOrder) {
    return {
      bank: fromOrder.refundBank || '',
      account: fromOrder.refundAccount || '',
      holder: fromOrder.refundHolder || '',
    }
  }
  return loadLastRefundAccount()
}

const orderDepositor = computed(() => String(order.value?.depositor || '').trim())
const holderPrefillFromDepositor = ref(false)

const showClaimHolderHint = computed(
  () =>
    holderPrefillFromDepositor.value &&
    Boolean(orderDepositor.value) &&
    claimForm.refundHolder === orderDepositor.value,
)

const showRefundHolderHint = computed(
  () =>
    holderPrefillFromDepositor.value &&
    Boolean(orderDepositor.value) &&
    refundForm.holder === orderDepositor.value,
)

function applyRefundHolder(savedHolder: string) {
  const saved = String(savedHolder || '').trim()
  if (saved) {
    holderPrefillFromDepositor.value = false
    return saved
  }
  const depositor = orderDepositor.value
  holderPrefillFromDepositor.value = Boolean(depositor)
  return depositor
}

const claimReturnNote = ref(
  '승인되면 운영팀이 위 계좌로 수동 입금합니다. PG 자동환불은 없습니다.',
)

function sellNoun(item: { sellUnit?: string }) {
  return item.sellUnit === 'BOX' ? '박스' : '개'
}

function frozenTerms(item: { leadTime?: string; cutoff?: string; returnEvery?: number; returnUnitFee?: number; sellUnit?: string }) {
  const noun = sellNoun(item)
  const every = Math.max(1, Number(item.returnEvery) || 0)
  const unitFee = Math.max(0, Number(item.returnUnitFee) || 0)
  const parts: string[] = []
  if (item.leadTime) parts.push(`출고 ${item.leadTime}`)
  if (item.cutoff) parts.push(`당일 마감 ${item.cutoff}`)
  if (every > 0) {
    parts.push(
      unitFee
        ? `환불 배송비 ${every}${noun}당 ${unitFee.toLocaleString('ko-KR')}원`
        : '환불 배송비 없음',
    )
  }
  return parts.join(' · ')
}

function describeReturnFee(item: {
  qty?: number
  returnEvery?: number
  returnUnitFee?: number
  returnFee?: number
  sellUnit?: string
  returnPolicy?: string
}) {
  const base = '승인되면 운영팀이 위 계좌로 수동 입금합니다. PG 자동환불은 없습니다.'
  const noun = sellNoun(item)
  const every = Math.max(1, Number(item.returnEvery) || 10)
  const unitFee = Math.max(0, Number(item.returnUnitFee) || 0)
  const qty = Math.max(0, Number(item.qty) || 0)
  const policy = String(item.returnPolicy || '').trim()
  const policyNote = policy ? ` 주문 당시 안내: ${policy.slice(0, 500)}` : ''
  if (!unitFee) {
    return `${base} 이 상품은 단순 변심 반품 배송비가 없습니다. 하자·오배송은 상품 금액 전액입니다.${policyNote}`
  }
  const blocks = qty > 0 ? Math.ceil(qty / every) : 1
  const total = (qty > 0 ? blocks * unitFee : Math.max(0, Number(item.returnFee) || unitFee)).toLocaleString('ko-KR')
  return `${base} 단순 변심은 주문 당시 기준 ${every}${noun}당 ${unitFee.toLocaleString('ko-KR')}원입니다. ${every}${noun} 이하는 한 번이고, 이번 ${qty}${noun}는 ${blocks} × ${unitFee.toLocaleString('ko-KR')}원 = ${total}원을 뺍니다. 하자·오배송은 상품 금액 전액입니다.${policyNote}`
}

function openClaim(idx: number, type: ClaimType, faultOnly = false) {
  claimForm.idx = idx
  claimForm.type = type
  claimForm.reason = ''
  claimForm.faultOnly = faultOnly
  claimForm.returnCause = faultOnly ? 'FAULT' : ''
  const pref = preferRefundAccount()
  claimForm.refundBank = pref?.bank || ''
  claimForm.refundAccount = pref?.account || ''
  claimForm.refundHolder = applyRefundHolder(pref?.holder || '')
  if (type === 'RETURN') {
    const item = (order.value?.items || []).find((row) => row.idx === idx)
    claimReturnNote.value = item ? describeReturnFee(item) : describeReturnFee({})
  }
}

function closeClaim() {
  claimForm.idx = 0
  claimForm.reason = ''
  claimForm.returnCause = ''
  claimForm.faultOnly = false
  claimForm.refundBank = ''
  claimForm.refundAccount = ''
  claimForm.refundHolder = ''
  holderPrefillFromDepositor.value = false
}

function onPayAction() {
  if (tossMountFailed.value) {
    refreshPay()
    return
  }
  void onContinueTossPay()
}

async function onContinueTossPay() {
  if (!order.value || tossPaying.value || !tossReady.value) return
  tossPaying.value = true
  try {
    const first = order.value.items?.[0]?.name || '함우리몰 상품'
    const extra = Math.max(0, (order.value.itemCount || order.value.items?.length || 1) - 1)
    await requestTossPay({
      orderId: order.value.code,
      orderName: (extra > 0 ? `${first} 외 ${extra}건` : first).slice(0, 100),
      amount: order.value.totalAmount,
      customerName: order.value.receiver,
      customerEmail: order.value.memberEmail,
    })
  } catch {
    payHold.value = true
  } finally {
    tossPaying.value = false
  }
}

async function mountOrderToss() {
  const current = order.value
  if (!current || !tossEnabled.value) return
  if (current.status !== 'PENDING' || current.payMethod !== 'TOSS') return
  await nextTick()
  try {
    await mountToss(
      { methods: '#order-toss-method', agreement: '#order-toss-agreement' },
      current.totalAmount,
    )
    tossMountFailed.value = false
  } catch {
    tossMountFailed.value = true
  }
}

async function load() {
  loading.value = true
  tossMountFailed.value = false

  try {
    const result = await fetchMyOrder(code.value)
    order.value = result.order
    payment.value = result.payment
    fillTaxFormFromMember()
    tossEnabled.value = await fetchTossAccess().catch(() => false)
  } catch {
    order.value = null
    tossEnabled.value = false
  } finally {
    loading.value = false
  }

  await mountOrderToss()
}

async function onRequestTax() {
  if (!order.value || taxRequesting.value) return

  const taxError = taxPanelRef.value?.validate()
  if (taxError) {
    showError(taxError)
    return
  }

  const ok = await confirmDialog({
    title: '세금계산서 발행 요청',
    message: taxPanelRef.value?.confirmMessage() || '이 주문에 세금계산서 발행을 요청할까요?',
    confirmLabel: '요청하기',
    tone: 'primary',
  })
  if (!ok) return

  taxRequesting.value = true
  try {
    await taxPanelRef.value?.persist()
    const result = await requestMyTaxInvoice(order.value.code, {
      bizName: taxForm.bizName.trim(),
      bizNum: taxForm.bizNum.trim(),
      email: taxForm.email.trim(),
    })
    order.value = result.order
    showSuccess(result.message)
  } catch (error) {
    showError(error instanceof Error ? error.message : '세금계산서 요청에 실패했습니다.')
  } finally {
    taxRequesting.value = false
  }
}

onMounted(() => {
  void load()
})

onUnmounted(() => {
  document.body.classList.remove(STATEMENT_PRINT_BODY_CLASS)
})

const statusIcon = computed(() => {
  if (order.value?.status === 'PAID') return 'mdi-check-circle-outline'
  if (order.value?.status === 'CANCELED') return 'mdi-close-circle-outline'
  if (order.value?.status === 'PENDING' && order.value.payNotifiedAt) {
    return 'mdi-bank-check'
  }
  return 'mdi-clock-outline'
})

const statusDesc = computed(() => {
  const card = order.value?.payMethod === 'TOSS'
  if (order.value?.status === 'PAID') {
    return card
      ? '결제가 완료되어 판매업체에 주문이 전달되었습니다.'
      : '입금이 확인되어 판매업체에 주문이 전달되었습니다.'
  }
  if (order.value?.status === 'CANCELED') {
    return order.value.cancelReason || '주문이 취소되었습니다.'
  }
  if (order.value?.status === 'PENDING') {
    if (!card && order.value.payNotifiedAt) {
      return '입금 알림을 보냈습니다. 운영팀이 통장을 확인 중입니다.'
    }
    if (card) {
      return `${pendingExpireLabel(order.value.orderedAt)}. 오른쪽에서 카드·간편결제를 마쳐 주세요.`
    }
    return `${pendingExpireLabel(order.value.orderedAt)}. 오른쪽 입금 계좌에서 이체한 뒤 「입금했어요」를 눌러 주세요.`
  }
  return '안내된 계좌로 입금해 주세요.'
})

const timelineSteps = computed(() => {
  const card = order.value?.payMethod === 'TOSS'
  return [
  { key: 'pending', label: card ? '결제대기' : '입금대기' },
  { key: 'paid', label: card ? '결제완료' : '입금확인' },
  { key: 'ready', label: '출고준비' },
  { key: 'shipping', label: '배송중' },
  { key: 'done', label: '완료' },
  ]
})

function itemProgressRank(status: MallOrderItemStatus) {
  switch (status) {
    case 'WAITING':
      return 0
    case 'PAID':
      return 1
    case 'READY':
      return 2
    case 'SHIPPING':
      return 3
    case 'DELIVERED':
    case 'DONE':
      return 4
    case 'CANCEL_REQUEST':
      return 1
    case 'RETURN_REQUEST':
      return 4
    case 'CANCELED':
      return -1
    default:
      return 0
  }
}

const timelineIndex = computed(() => {
  if (!order.value || order.value.status === 'CANCELED') return 0
  if (order.value.status === 'PENDING') return 0

  const ranks = (order.value.items || [])
    .map((item) => itemProgressRank(item.status))
    .filter((rank) => rank >= 0)

  if (!ranks.length) return 1
  return Math.min(...ranks)
})

const timelineNote = computed(() => {
  if (!order.value) return ''
  if (order.value.status === 'PENDING') {
    if (order.value.payMethod === 'TOSS') {
      return `${pendingExpireLabel(order.value.orderedAt)}. 카드·간편결제를 마쳐 주세요. ${PENDING_EXPIRE_DAYS}일 안에 결제하지 않으면 주문이 자동 취소됩니다.`
    }
    if (order.value.payNotifiedAt) {
      return '입금 알림을 보냈습니다. 운영팀이 확인하면 출고 준비로 넘어갑니다.'
    }
    return `${pendingExpireLabel(order.value.orderedAt)}. 계좌이체 후 「입금했어요」를 눌러 주세요. ${PENDING_EXPIRE_DAYS}일 안에 누르지 않으면 주문이 자동 취소됩니다.`
  }

  const labels = timelineSteps.value[timelineIndex.value]?.label || ''
  const active = (order.value.items || []).filter((item) => item.status !== 'CANCELED')
  if (!active.length) return '처리 중인 상품이 없습니다.'
  if (timelineIndex.value >= 4) {
    const waiting = active.find((item) => item.status === 'DELIVERED' && item.deliveredAt)
    if (waiting?.deliveredAt) {
      return `배송이 완료되었습니다. ${autoConfirmLabel(waiting.deliveredAt)}.`
    }
    return '모든 상품 배송이 완료되었습니다.'
  }
  if (active.length === 1) return `현재 단계: ${labels}`
  return `여러 상품 중 가장 늦은 기준 · 현재 ${labels}`
})

async function copyText(value: string, field: 'account' | 'amount' | 'depositor', label: string) {
  const ok = await copyToClipboard(value)
  if (!ok) {
    showError(`${label} 복사에 실패했습니다. 직접 선택해 복사해 주세요.`)
    return
  }
  copiedField.value = field
  showSuccess(`${label}을(를) 복사했습니다.`)
  setTimeout(() => {
    if (copiedField.value === field) copiedField.value = ''
  }, 2000)
}

async function copyAccount() {
  if (!payment.value) return
  await copyText(payment.value.account.replace(/\s/g, ''), 'account', '계좌번호')
}

async function copyAmount() {
  if (!order.value) return
  await copyText(String(order.value.totalAmount), 'amount', '입금 금액')
}

async function copyDepositor() {
  if (!order.value) return
  const name = order.value.depositor || order.value.receiver
  await copyText(name, 'depositor', '입금자명')
}

async function onNotifyPayment() {
  if (notifying.value || !order.value || order.value.payNotifiedAt) return
  const ok = await confirmDialog({
    title: '입금 알림',
    message: '계좌로 입금하셨나요? 운영팀이 통장을 확인합니다.',
    detail: order.value
      ? `${order.value.code}\n입금액 ${formatPrice(order.value.totalAmount)}원`
      : '',
    confirmLabel: '입금했어요',
    tone: 'primary',
  })
  if (!ok) return

  notifying.value = true
  try {
    const result = await notifyMyPayment(code.value)
    order.value = result.order
    showSuccess(result.message || '입금 완료를 알려 주셨습니다.')
  } catch (error) {
    showError(error)
  } finally {
    notifying.value = false
  }
}

async function onReorder() {
  if (reordering.value || !order.value?.items?.length) return
  reordering.value = true
  try {
    for (const item of order.value.items) {
      if (!item.productCode || item.status === 'CANCELED') continue
      await addItem(
        item.productCode,
        item.qty,
        item.option ? { name: item.option, extra: 0 } : undefined,
      )
    }
    showSuccess('장바구니에 담았습니다.')
    router.push('/mall/cart')
  } catch (error) {
    showError(error)
  } finally {
    reordering.value = false
  }
}

async function onCancel() {
  if (canceling.value) return
  const ok = await confirmDialog({
    title: '주문 취소',
    message: order.value?.payMethod === 'TOSS'
      ? '주문을 취소할까요? 결제 전에만 취소할 수 있습니다.'
      : '주문을 취소할까요? 입금 전에만 취소할 수 있습니다.',
    confirmLabel: '주문 취소',
    tone: 'danger',
  })
  if (!ok) return

  canceling.value = true

  try {
    await cancelMyOrder(code.value)
    await load()
    showSuccess('주문을 취소했습니다.')
  } catch (error) {
    showError(error)
  } finally {
    canceling.value = false
  }
}

async function submitClaim() {
  if (claiming.value || !claimForm.idx || !canSubmitClaim.value) return

  claiming.value = claimForm.idx
  try {
    await requestOrderItemClaim(claimForm.idx, {
      type: claimForm.type,
      reason: claimForm.reason,
      returnCause: claimForm.type === 'RETURN' ? claimForm.returnCause : '',
      refundBank: claimForm.refundBank,
      refundAccount: claimForm.refundAccount,
      refundHolder: claimForm.refundHolder,
    })
    const claimType = claimForm.type
    saveLastRefundAccount(
      claimForm.refundBank,
      claimForm.refundAccount,
      claimForm.refundHolder,
    )
    closeClaim()
    await load()
    showSuccess(
      claimType === 'CANCEL'
        ? order.value?.payMethod === 'TOSS'
          ? '환불신청이 접수되었습니다. 주문이 취소되었고 결제했던 카드·간편결제로 환불됩니다.'
          : '환불신청이 접수되었습니다. 주문이 취소되었고 운영팀이 환불을 진행합니다.'
        : order.value?.payMethod === 'TOSS'
          ? '반품 요청을 보냈습니다. 승인되면 결제했던 카드·간편결제로 환불됩니다.'
          : '반품 요청을 보냈습니다.',
    )
  } catch (error) {
    showError(error)
  } finally {
    claiming.value = 0
  }
}

async function onConfirmPurchase(idx: number) {
  if (confirming.value) return
  const ok = await confirmDialog({
    title: '구매 확정',
    message: '구매를 확정할까요? 확정 뒤에는 단순 변심 반품은 할 수 없고, 상품 하자·오배송만 요청할 수 있습니다.',
    confirmLabel: '구매 확정',
    tone: 'primary',
  })
  if (!ok) return

  confirming.value = idx
  try {
    await confirmOrderItemPurchase(idx)
    await load()
    showSuccess('구매를 확정했습니다.')
  } catch (error) {
    showError(error)
  } finally {
    confirming.value = 0
  }
}

async function copyInvoice(invoice: string) {
  const ok = await copyToClipboard(invoice.replace(/\s/g, ''))
  if (ok) {
    showSuccess('송장번호를 복사했습니다.')
    return
  }
  showError('송장번호 복사에 실패했습니다. 직접 선택해 복사해 주세요.')
}

function openRefundAccount(item: MallOrderItem) {
  refundForm.idx = item.idx
  const pref = preferRefundAccount()
  refundForm.bank = item.refundBank || pref?.bank || ''
  refundForm.account = item.refundAccount || pref?.account || ''
  refundForm.holder = applyRefundHolder(item.refundHolder || pref?.holder || '')
}

async function submitRefundAccount() {
  if (!refundForm.idx || refundSaving.value) return
  refundSaving.value = refundForm.idx
  try {
    await updateOrderItemRefundAccount(refundForm.idx, {
      refundBank: refundForm.bank,
      refundAccount: refundForm.account,
      refundHolder: refundForm.holder,
    })
    saveLastRefundAccount(refundForm.bank, refundForm.account, refundForm.holder)
    refundForm.idx = 0
    await load()
    showSuccess('환불 계좌를 저장했습니다.')
  } catch (error) {
    showError(error)
  } finally {
    refundSaving.value = 0
  }
}

function formatDateTime(value: string | null): string {
  if (!value) return '-'
  const date = new Date(value)
  return `${date.getFullYear()}.${String(date.getMonth() + 1).padStart(2, '0')}.${String(
    date.getDate(),
  ).padStart(2, '0')} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`
}

/* 목록에서 넘어온 뒤 주소가 바뀌면 다시 읽는다 */
router.afterEach((to) => {
  if (to.name === 'mall-order-detail' && to.params.code !== order.value?.code) {
    load()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("nav", _hoisted_3, [
        _createVNode(_component_router_link, { to: "/mall" }, {
          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
            _createTextVNode("함우리몰", -1)
          ]))]),
          _: 1
        }),
        _createVNode(AppIcon, {
          icon: "mdi-chevron-right",
          size: 16
        }),
        _createVNode(_component_router_link, { to: "/mall/orders" }, {
          default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
            _createTextVNode("주문내역", -1)
          ]))]),
          _: 1
        }),
        _createVNode(AppIcon, {
          icon: "mdi-chevron-right",
          size: 16
        }),
        _createElementVNode("span", null, _toDisplayString(code.value), 1)
      ]),
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(AppIcon, {
              icon: "mdi-loading",
              size: 40
            }),
            _cache[15] || (_cache[15] = _createElementVNode("p", null, "주문을 불러오는 중입니다…", -1))
          ]))
        : (!order.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(AppIcon, {
                icon: "mdi-file-search-outline",
                size: 48
              }),
              _cache[17] || (_cache[17] = _createElementVNode("p", null, "주문을 찾을 수 없습니다.", -1)),
              _createVNode(_component_router_link, {
                to: _unref(MALL_ORDERS_PATH),
                class: "order-detail__link"
              }, {
                default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                  _createTextVNode("주문내역으로", -1)
                ]))]),
                _: 1
              }, 8, ["to"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("section", {
                  class: _normalizeClass(["order-detail__card order-detail__status", 
              order.value.status === 'PENDING' && order.value.payNotifiedAt
                ? 'is-confirming'
                : `is-${order.value.status.toLowerCase()}`
            ])
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(AppIcon, {
                      icon: statusIcon.value,
                      size: 26
                    }, null, 8, ["icon"])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(mallBuyerOrderStatusLabel)(order.value)), 1),
                    _createElementVNode("p", _hoisted_11, _toDisplayString(statusDesc.value), 1),
                    (order.value.status === 'PENDING' && !order.value.payNotifiedAt)
                      ? (_openBlock(), _createElementBlock("p", {
                          key: 0,
                          class: _normalizeClass(["order-detail__expire-note", {
                  'is-warn': _unref(pendingExpireTone)(order.value.orderedAt) === 'warn',
                  'is-alert': _unref(pendingExpireTone)(order.value.orderedAt) === 'alert',
                }])
                        }, _toDisplayString(_unref(pendingExpireLabel)(order.value.orderedAt)) + " · " + _toDisplayString(_unref(PENDING_EXPIRE_DAYS)) + "일 안에 " + _toDisplayString(order.value.payMethod === 'TOSS' ? '결제' : '입금') + "하지 않으면 주문이 자동 취소됩니다 ", 3))
                      : (order.value.status === 'PENDING' && order.value.payNotifiedAt)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_12, " 입금 알림을 보냈습니다. 운영팀이 통장을 확인 중입니다. "))
                        : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("dl", _hoisted_13, [
                    _createElementVNode("div", null, [
                      _cache[18] || (_cache[18] = _createElementVNode("dt", null, "주문번호", -1)),
                      _createElementVNode("dd", null, _toDisplayString(order.value.code), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[19] || (_cache[19] = _createElementVNode("dt", null, "주문일시", -1)),
                      _createElementVNode("dd", null, _toDisplayString(formatDateTime(order.value.orderedAt)), 1)
                    ]),
                    (order.value.paidAt)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _cache[20] || (_cache[20] = _createElementVNode("dt", null, "확인일시", -1)),
                          _createElementVNode("dd", null, _toDisplayString(formatDateTime(order.value.paidAt)), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_router_link, {
                    to: `/mall/mypage/consults/write?order=${encodeURIComponent(order.value.code)}`,
                    class: "order-detail__inquiry-link no-print"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(AppIcon, {
                        icon: "mdi-forum-outline",
                        size: 15
                      }),
                      _cache[21] || (_cache[21] = _createTextVNode(" 이 주문 문의하기 ", -1))
                    ]),
                    _: 1
                  }, 8, ["to"])
                ], 2),
                (order.value.status === 'PENDING' && order.value.payMethod === 'TOSS')
                  ? (_openBlock(), _createElementBlock("section", _hoisted_15, [
                      _createElementVNode("header", _hoisted_16, [
                        _cache[22] || (_cache[22] = _createElementVNode("div", null, [
                          _createElementVNode("h2", null, "이어서 결제"),
                          _createElementVNode("p", null, "카드 또는 간편결제로 남은 금액을 냅니다.")
                        ], -1)),
                        _createElementVNode("strong", null, _toDisplayString(_unref(formatPrice)(order.value.totalAmount)) + "원", 1)
                      ]),
                      (tossEnabled.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _cache[23] || (_cache[23] = _createElementVNode("div", {
                              id: "order-toss-method",
                              class: "order-detail__pay-frame"
                            }, null, -1)),
                            _cache[24] || (_cache[24] = _createElementVNode("div", {
                              id: "order-toss-agreement",
                              class: "order-detail__pay-frame"
                            }, null, -1)),
                            _createElementVNode("p", _hoisted_17, _toDisplayString(payNotice.value), 1),
                            (_unref(tossTestMode))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_18, " 테스트 결제입니다. 승인해도 카드에서 금액이 빠지지 않습니다. "))
                              : _createCommentVNode("", true),
                            _createElementVNode("button", {
                              type: "button",
                              class: "order-detail__pay-go",
                              disabled: payButtonDisabled.value,
                              onClick: onPayAction
                            }, _toDisplayString(payButtonLabel.value), 9, _hoisted_19)
                          ], 64))
                        : (_openBlock(), _createElementBlock("p", _hoisted_20, " 결제창을 불러오지 못했습니다. 잠시 후 새로고침해 주세요. "))
                    ]))
                  : _createCommentVNode("", true),
                (showFulfillment.value)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_21, [
                      _createElementVNode("ol", _hoisted_22, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timelineSteps.value, (step, index) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: step.key,
                            class: _normalizeClass(["order-detail__step", {
                  'is-done': index < timelineIndex.value,
                  'is-current': index === timelineIndex.value,
                }])
                          }, [
                            _createElementVNode("span", _hoisted_23, [
                              (index < timelineIndex.value)
                                ? (_openBlock(), _createBlock(AppIcon, {
                                    key: 0,
                                    icon: "mdi-check",
                                    size: 14
                                  }))
                                : (_openBlock(), _createElementBlock("em", _hoisted_24, _toDisplayString(index + 1), 1))
                            ]),
                            _createElementVNode("span", _hoisted_25, _toDisplayString(step.label), 1)
                          ], 2))
                        }), 128))
                      ]),
                      _createElementVNode("p", _hoisted_26, _toDisplayString(timelineNote.value), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("section", _hoisted_27, [
                  _createElementVNode("h2", null, [
                    _cache[25] || (_cache[25] = _createTextVNode("주문 내역 ", -1)),
                    _createElementVNode("em", null, _toDisplayString(order.value.items?.length ?? 0) + "건", 1)
                  ]),
                  _createElementVNode("ul", _hoisted_28, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.value.items, (item) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: item.idx
                      }, [
                        (item.image)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: item.image,
                              alt: item.name,
                              loading: "lazy"
                            }, null, 8, _hoisted_29))
                          : (_openBlock(), _createElementBlock("span", _hoisted_30, [
                              _createVNode(AppIcon, {
                                icon: "mdi-image-off-outline",
                                size: 18
                              })
                            ])),
                        _createElementVNode("div", _hoisted_31, [
                          _createElementVNode("p", _hoisted_32, _toDisplayString(item.name), 1),
                          _createElementVNode("p", _hoisted_33, [
                            (item.option)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(item.option) + " · ", 1)
                                ], 64))
                              : _createCommentVNode("", true),
                            (item.storeName)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(item.storeName) + " · ", 1)
                                ], 64))
                              : _createCommentVNode("", true),
                            _createTextVNode(" " + _toDisplayString(item.qty) + _toDisplayString(sellNoun(item)), 1)
                          ]),
                          (frozenTerms(item))
                            ? (_openBlock(), _createElementBlock("p", _hoisted_34, _toDisplayString(frozenTerms(item)), 1))
                            : _createCommentVNode("", true),
                          (showFulfillment.value && (item.invoice || item.shipments?.length))
                            ? (_openBlock(), _createBlock(MallShipmentLedger, {
                                key: 1,
                                item: item,
                                "lookup-tour": "mall-order-tracking",
                                onTrack: ($event: any) => (openItemShipment(item, $event))
                              }, null, 8, ["item", "onTrack"]))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("strong", null, _toDisplayString(_unref(formatPrice)(item.amount)) + "원", 1),
                          (showFulfillment.value)
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: _normalizeClass(["order-detail__item-status", `is-${item.status.toLowerCase()}`])
                              }, _toDisplayString(_unref(MALL_ORDER_ITEM_STATUS_LABEL)[item.status]), 3))
                            : _createCommentVNode("", true),
                          (showFulfillment.value && canConfirm(item.status) && claimForm.idx !== item.idx)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 1,
                                type: "button",
                                class: "order-detail__claim-btn order-detail__claim-btn--primary",
                                disabled: confirming.value === item.idx,
                                onClick: ($event: any) => (onConfirmPurchase(item.idx))
                              }, _toDisplayString(confirming.value === item.idx ? '처리 중…' : '구매확정'), 9, _hoisted_36))
                            : _createCommentVNode("", true),
                          (showFulfillment.value && canClaimRefund(item.status) && claimForm.idx !== item.idx)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 2,
                                type: "button",
                                class: "order-detail__claim-btn",
                                onClick: ($event: any) => (openClaim(item.idx, 'CANCEL'))
                              }, " 환불신청 ", 8, _hoisted_37))
                            : _createCommentVNode("", true),
                          (showFulfillment.value && canClaimReturn(item.status) && claimForm.idx !== item.idx)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 3,
                                type: "button",
                                class: "order-detail__claim-btn",
                                onClick: ($event: any) => (openClaim(item.idx, 'RETURN'))
                              }, " 반품 요청 ", 8, _hoisted_38))
                            : _createCommentVNode("", true),
                          (showFulfillment.value && canClaimFault(item.status) && claimForm.idx !== item.idx)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 4,
                                type: "button",
                                class: "order-detail__claim-btn",
                                onClick: ($event: any) => (openClaim(item.idx, 'RETURN', true))
                              }, " 하자·오배송 반품 ", 8, _hoisted_39))
                            : _createCommentVNode("", true),
                          (
                      showFulfillment.value &&
                      item.status === 'SHIPPING' &&
                      claimForm.idx !== item.idx
                    )
                            ? (_openBlock(), _createElementBlock("p", _hoisted_40, " 배송 중에는 환불신청할 수 없습니다. 받으신 뒤 반품으로 요청해 주세요. "))
                            : _createCommentVNode("", true),
                          (showFulfillment.value && canReview(item) && claimForm.idx !== item.idx)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 6,
                                to: `/mall/${item.productCode}?tab=review`,
                                class: "order-detail__claim-btn"
                              }, {
                                default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                                  _createTextVNode(" 후기 작성 ", -1)
                                ]))]),
                                _: 1
                              }, 8, ["to"]))
                            : _createCommentVNode("", true),
                          (
                      showFulfillment.value &&
                      (item.status === 'CANCEL_REQUEST' || item.status === 'RETURN_REQUEST')
                    )
                            ? (_openBlock(), _createElementBlock("p", _hoisted_41, " 판매업체 확인 대기 중 · " + _toDisplayString(item.claimReason), 1))
                            : (
                      showFulfillment.value && item.claimReason && item.status === 'CANCELED'
                    )
                              ? (_openBlock(), _createElementBlock("p", _hoisted_42, " 승인됨 · " + _toDisplayString(item.claimReason), 1))
                              : (showFulfillment.value && item.claimRejectReason)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_43, " 반려됨 · " + _toDisplayString(item.claimRejectReason), 1))
                                : (
                      showFulfillment.value && item.status === 'DELIVERED' && item.deliveredAt
                    )
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_44, _toDisplayString(_unref(autoConfirmLabel)(item.deliveredAt)) + ". 그 전에 구매확정을 누를 수도 있습니다. ", 1))
                                  : _createCommentVNode("", true)
                        ]),
                        (showFulfillment.value && claimForm.idx === item.idx)
                          ? (_openBlock(), _createElementBlock("form", {
                              key: 2,
                              class: "order-detail__panel",
                              onSubmit: _withModifiers(submitClaim, ["prevent"])
                            }, [
                              _createElementVNode("header", _hoisted_45, [
                                _createElementVNode("strong", null, _toDisplayString(claimForm.type === 'RETURN' ? '반품 요청' : '환불신청'), 1),
                                _createElementVNode("span", null, "환불 예정 " + _toDisplayString(_unref(formatPrice)(claimRefundPreview(item))) + "원", 1)
                              ]),
                              (claimForm.type === 'RETURN')
                                ? (_openBlock(), _createElementBlock("fieldset", _hoisted_46, [
                                    _cache[28] || (_cache[28] = _createElementVNode("legend", null, "반품 구분", -1)),
                                    (!claimForm.faultOnly)
                                      ? (_openBlock(), _createElementBlock("label", _hoisted_47, [
                                          _withDirectives(_createElementVNode("input", {
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((claimForm.returnCause) = $event)),
                                            type: "radio",
                                            value: "CHANGE"
                                          }, null, 512), [
                                            [_vModelRadio, claimForm.returnCause]
                                          ]),
                                          _createElementVNode("span", null, "단순 변심 · 반품 배송비 " + _toDisplayString(_unref(formatPrice)(item.returnFee || 0)) + "원 차감", 1)
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("label", null, [
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((claimForm.returnCause) = $event)),
                                        type: "radio",
                                        value: "FAULT"
                                      }, null, 512), [
                                        [_vModelRadio, claimForm.returnCause]
                                      ]),
                                      _cache[27] || (_cache[27] = _createElementVNode("span", null, "상품 하자·오배송 · 상품 금액 전액", -1))
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("label", _hoisted_48, [
                                _cache[29] || (_cache[29] = _createElementVNode("span", null, "요청 사유", -1)),
                                _withDirectives(_createElementVNode("textarea", {
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((claimForm.reason) = $event)),
                                  rows: "3",
                                  maxlength: "255",
                                  placeholder: "사유를 구체적으로 적어 주세요."
                                }, null, 512), [
                                  [
                                    _vModelText,
                                    claimForm.reason,
                                    void 0,
                                    { trim: true }
                                  ]
                                ])
                              ]),
                              (order.value.payMethod !== 'TOSS')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                    _createElementVNode("label", _hoisted_50, [
                                      _cache[31] || (_cache[31] = _createElementVNode("span", null, "은행", -1)),
                                      _withDirectives(_createElementVNode("select", {
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((claimForm.refundBank) = $event))
                                      }, [
                                        _cache[30] || (_cache[30] = _createElementVNode("option", {
                                          value: "",
                                          disabled: ""
                                        }, "선택", -1)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(MALL_BANKS), (bank) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: bank,
                                            value: bank
                                          }, _toDisplayString(bank), 9, _hoisted_51))
                                        }), 128))
                                      ], 512), [
                                        [_vModelSelect, claimForm.refundBank]
                                      ])
                                    ]),
                                    _createElementVNode("label", _hoisted_52, [
                                      _cache[32] || (_cache[32] = _createElementVNode("span", null, "계좌번호", -1)),
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((claimForm.refundAccount) = $event)),
                                        type: "text",
                                        inputmode: "numeric",
                                        maxlength: "50",
                                        placeholder: "숫자만 입력"
                                      }, null, 512), [
                                        [
                                          _vModelText,
                                          claimForm.refundAccount,
                                          void 0,
                                          { trim: true }
                                        ]
                                      ])
                                    ]),
                                    _createElementVNode("label", _hoisted_53, [
                                      _cache[33] || (_cache[33] = _createElementVNode("span", null, "예금주", -1)),
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((claimForm.refundHolder) = $event)),
                                        type: "text",
                                        maxlength: "50",
                                        placeholder: orderDepositor.value || '예금주명'
                                      }, null, 8, _hoisted_54), [
                                        [
                                          _vModelText,
                                          claimForm.refundHolder,
                                          void 0,
                                          { trim: true }
                                        ]
                                      ]),
                                      (showClaimHolderHint.value)
                                        ? (_openBlock(), _createElementBlock("em", _hoisted_55, " 주문 때 적은 입금자명입니다. 환불 받을 통장의 예금주와 같은지 확인해 주세요. "))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("p", _hoisted_56, _toDisplayString(order.value.payMethod === 'TOSS'
                        ? claimForm.type === 'CANCEL'
                          ? '배송 시작 전까지만 환불신청할 수 있습니다. 신청하면 주문이 바로 취소되고, 결제했던 카드·간편결제로 환불됩니다. 그 판매업체 상품이 이것까지면 그 업체 출고 배송비도 함께 취소됩니다.'
                          : '승인되면 위에 적힌 금액이 결제했던 카드·간편결제로 돌아갑니다. 단순 변심은 반품 배송비를 빼고, 하자·오배송은 상품 금액 전액입니다. 처음 낸 출고 배송비는 반품에서 빼지 않습니다.'
                        : claimForm.type === 'CANCEL'
                          ? '입금 확인된 주문은 배송 시작 전까지만 환불신청할 수 있습니다. 신청하면 주문이 바로 취소되고, 운영팀이 위에 적힌 금액으로 환불합니다. 그 판매업체 상품이 이것까지면 그 업체 출고 배송비도 포함됩니다. 이 계좌는 회원 환불계좌로 저장됩니다.'
                          : `${claimReturnNote.value} 이 계좌는 회원 환불계좌로 저장됩니다.`), 1),
                              _createElementVNode("div", _hoisted_57, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "order-detail__ghost",
                                  onClick: closeClaim
                                }, "닫기"),
                                _createElementVNode("button", {
                                  type: "submit",
                                  class: "order-detail__claim-submit",
                                  disabled: claiming.value === item.idx || !canSubmitClaim.value
                                }, _toDisplayString(claiming.value === item.idx
                          ? '처리 중…'
                          : claimForm.type === 'CANCEL'
                            ? '환불신청하기'
                            : '요청 보내기'), 9, _hoisted_58)
                              ])
                            ], 32))
                          : (
                    showFulfillment.value &&
                    order.value.payMethod !== 'TOSS' &&
                    item.refundStatus === 'PENDING' &&
                    !item.refundAccount &&
                    refundForm.idx !== item.idx
                  )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                _createElementVNode("div", null, [
                                  _cache[34] || (_cache[34] = _createElementVNode("strong", null, "환불 계좌가 필요합니다", -1)),
                                  _createElementVNode("p", null, "환불 예정 " + _toDisplayString(_unref(formatPrice)(item.refundAmount || item.amount)) + "원", 1)
                                ]),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "order-detail__claim-submit",
                                  onClick: ($event: any) => (openRefundAccount(item))
                                }, " 계좌 입력 ", 8, _hoisted_60)
                              ]))
                            : (showFulfillment.value && refundForm.idx === item.idx)
                              ? (_openBlock(), _createElementBlock("form", {
                                  key: 4,
                                  class: "order-detail__panel",
                                  onSubmit: _withModifiers(submitRefundAccount, ["prevent"])
                                }, [
                                  _createElementVNode("header", _hoisted_61, [
                                    _cache[35] || (_cache[35] = _createElementVNode("strong", null, "환불 받을 계좌", -1)),
                                    _createElementVNode("span", null, _toDisplayString(_unref(formatPrice)(item.refundAmount || item.amount)) + "원", 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_62, [
                                    _createElementVNode("label", _hoisted_63, [
                                      _cache[37] || (_cache[37] = _createElementVNode("span", null, "은행", -1)),
                                      _withDirectives(_createElementVNode("select", {
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((refundForm.bank) = $event))
                                      }, [
                                        _cache[36] || (_cache[36] = _createElementVNode("option", {
                                          value: "",
                                          disabled: ""
                                        }, "선택", -1)),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(MALL_BANKS), (bank) => {
                                          return (_openBlock(), _createElementBlock("option", {
                                            key: bank,
                                            value: bank
                                          }, _toDisplayString(bank), 9, _hoisted_64))
                                        }), 128))
                                      ], 512), [
                                        [_vModelSelect, refundForm.bank]
                                      ])
                                    ]),
                                    _createElementVNode("label", _hoisted_65, [
                                      _cache[38] || (_cache[38] = _createElementVNode("span", null, "계좌번호", -1)),
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((refundForm.account) = $event)),
                                        type: "text",
                                        inputmode: "numeric",
                                        maxlength: "50",
                                        placeholder: "숫자만 입력"
                                      }, null, 512), [
                                        [
                                          _vModelText,
                                          refundForm.account,
                                          void 0,
                                          { trim: true }
                                        ]
                                      ])
                                    ]),
                                    _createElementVNode("label", _hoisted_66, [
                                      _cache[39] || (_cache[39] = _createElementVNode("span", null, "예금주", -1)),
                                      _withDirectives(_createElementVNode("input", {
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((refundForm.holder) = $event)),
                                        type: "text",
                                        maxlength: "50",
                                        placeholder: orderDepositor.value || '예금주명'
                                      }, null, 8, _hoisted_67), [
                                        [
                                          _vModelText,
                                          refundForm.holder,
                                          void 0,
                                          { trim: true }
                                        ]
                                      ]),
                                      (showRefundHolderHint.value)
                                        ? (_openBlock(), _createElementBlock("em", _hoisted_68, " 주문 때 적은 입금자명입니다. 환불 받을 통장의 예금주와 같은지 확인해 주세요. "))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_69, [
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "order-detail__ghost",
                                      onClick: _cache[9] || (_cache[9] = ($event: any) => (refundForm.idx = 0))
                                    }, "닫기"),
                                    _createElementVNode("button", {
                                      type: "submit",
                                      class: "order-detail__claim-submit",
                                      disabled: 
                        refundSaving.value === item.idx || !refundForm.bank || !refundForm.account || !refundForm.holder
                      
                                    }, _toDisplayString(refundSaving.value === item.idx ? '저장 중…' : '계좌 저장'), 9, _hoisted_70)
                                  ])
                                ], 32))
                              : (
                    showFulfillment.value &&
                    (item.refundStatus === 'PENDING' || item.refundStatus === 'DONE')
                  )
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 5,
                                    class: _normalizeClass(["order-detail__refund-card", item.refundStatus === 'DONE' ? 'is-done' : 'is-pending'])
                                  }, [
                                    _createElementVNode("span", _hoisted_71, _toDisplayString(_unref(MALL_REFUND_STATUS_LABEL)[item.refundStatus]), 1),
                                    _createElementVNode("strong", null, _toDisplayString(_unref(formatPrice)(item.refundAmount || item.amount)) + "원", 1),
                                    (item.refundBank)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_72, _toDisplayString(item.refundBank) + " " + _toDisplayString(item.refundAccount) + " · " + _toDisplayString(item.refundHolder), 1))
                                      : _createCommentVNode("", true)
                                  ], 2))
                                : _createCommentVNode("", true)
                      ]))
                    }), 128))
                  ]),
                  _createElementVNode("dl", _hoisted_73, [
                    _createElementVNode("div", null, [
                      _cache[40] || (_cache[40] = _createElementVNode("dt", null, "상품금액", -1)),
                      _createElementVNode("dd", null, _toDisplayString(_unref(formatPrice)(order.value.itemAmount)) + "원", 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[41] || (_cache[41] = _createElementVNode("dt", null, "주문 배송비", -1)),
                      _createElementVNode("dd", null, _toDisplayString(_unref(formatShippingFeeAmount)(order.value.shippingFee)), 1)
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass({ 'is-total': !refundRelation.value.refunded })
                    }, [
                      _createElementVNode("dt", null, _toDisplayString(chargeAmountLabel.value), 1),
                      _createElementVNode("dd", null, _toDisplayString(_unref(formatPrice)(order.value.totalAmount)) + "원", 1)
                    ], 2),
                    (refundRelation.value.refunded)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                          _cache[42] || (_cache[42] = _createElementVNode("dt", null, "환불 완료", -1)),
                          _createElementVNode("dd", null, "-" + _toDisplayString(_unref(formatPrice)(refundRelation.value.refunded)) + "원", 1)
                        ]))
                      : _createCommentVNode("", true),
                    (refundRelation.value.refundPending)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                          _cache[43] || (_cache[43] = _createElementVNode("dt", null, "환불 대기", -1)),
                          _createElementVNode("dd", null, _toDisplayString(_unref(formatPrice)(refundRelation.value.refundPending)) + "원", 1)
                        ]))
                      : _createCommentVNode("", true),
                    (refundRelation.value.refunded)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                          _cache[44] || (_cache[44] = _createElementVNode("dt", null, "결제 잔액", -1)),
                          _createElementVNode("dd", null, _toDisplayString(_unref(formatPrice)(refundRelation.value.balance)) + "원", 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("section", _hoisted_77, [
                  _cache[49] || (_cache[49] = _createElementVNode("h2", null, "배송지", -1)),
                  _createElementVNode("dl", _hoisted_78, [
                    _createElementVNode("div", null, [
                      _cache[45] || (_cache[45] = _createElementVNode("dt", null, "받는 분", -1)),
                      _createElementVNode("dd", null, _toDisplayString(order.value.receiver), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[46] || (_cache[46] = _createElementVNode("dt", null, "연락처", -1)),
                      _createElementVNode("dd", null, _toDisplayString(order.value.phone), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _cache[47] || (_cache[47] = _createElementVNode("dt", null, "주소", -1)),
                      _createElementVNode("dd", null, _toDisplayString(order.value.address) + " " + _toDisplayString(order.value.addressDetail), 1)
                    ]),
                    (order.value.memo)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                          _cache[48] || (_cache[48] = _createElementVNode("dt", null, "요청사항", -1)),
                          _createElementVNode("dd", null, _toDisplayString(order.value.memo), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (showTaxCard.value)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_80, [
                      _cache[56] || (_cache[56] = _createElementVNode("h2", null, "세금계산서", -1)),
                      (hasTaxRecord.value)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createElementVNode("dl", _hoisted_81, [
                              _createElementVNode("div", null, [
                                _cache[50] || (_cache[50] = _createElementVNode("dt", null, "상태", -1)),
                                _createElementVNode("dd", null, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["order-detail__tax-status", {
                        'is-requested': currentTaxStatus.value === 'REQUESTED',
                        'is-done': currentTaxStatus.value === 'DONE',
                      }])
                                  }, _toDisplayString(taxStatusLabel.value), 3),
                                  (currentTaxStatus.value === 'DONE' && order.value.taxAt)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                        _createTextVNode(" · " + _toDisplayString(formatDateTime(order.value.taxAt)), 1)
                                      ], 64))
                                    : _createCommentVNode("", true)
                                ])
                              ]),
                              (order.value.bizName)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                    _cache[51] || (_cache[51] = _createElementVNode("dt", null, "상호", -1)),
                                    _createElementVNode("dd", null, _toDisplayString(order.value.bizName), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (order.value.bizNum)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                                    _cache[52] || (_cache[52] = _createElementVNode("dt", null, "사업자번호", -1)),
                                    _createElementVNode("dd", null, _toDisplayString(_unref(formatBizNumber)(order.value.bizNum)), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (order.value.taxEmail)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                                    _cache[53] || (_cache[53] = _createElementVNode("dt", null, "수신 이메일", -1)),
                                    _createElementVNode("dd", null, _toDisplayString(order.value.taxEmail), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (currentTaxStatus.value === 'DONE' && order.value.taxDocUrl)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                    _cache[54] || (_cache[54] = _createElementVNode("dt", null, "문서", -1)),
                                    _createElementVNode("dd", null, [
                                      _createElementVNode("a", {
                                        href: order.value.taxDocUrl,
                                        class: "order-detail__link",
                                        target: "_blank",
                                        rel: "noopener"
                                      }, " 세금계산서 보기 ", 8, _hoisted_86)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            (order.value.status === 'PENDING' && currentTaxStatus.value === 'REQUESTED')
                              ? (_openBlock(), _createElementBlock("p", _hoisted_87, " 주문할 때 요청해 두었습니다. 입금이 확인된 뒤 발행됩니다. "))
                              : (currentTaxStatus.value === 'REQUESTED')
                                ? (_openBlock(), _createElementBlock("p", _hoisted_88, " 운영팀이 확인한 뒤 세금계산서를 발행합니다. "))
                                : _createCommentVNode("", true)
                          ], 64))
                        : (_openBlock(), _createElementBlock("form", {
                            key: 1,
                            class: "order-detail__tax-form",
                            onSubmit: _withModifiers(onRequestTax, ["prevent"])
                          }, [
                            (order.value.taxRejectReason)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_89, " 이전 발행 요청이 반려되었습니다. " + _toDisplayString(order.value.taxRejectReason), 1))
                              : _createCommentVNode("", true),
                            _cache[55] || (_cache[55] = _createElementVNode("p", { class: "order-detail__tax-hint" }, " 입금이 확인된 주문에 한해 세금계산서 발행을 요청할 수 있습니다. ", -1)),
                            _createVNode(TaxInvoiceRequestPanel, {
                              ref_key: "taxPanelRef",
                              ref: taxPanelRef,
                              "show-toggle": false,
                              compact: true,
                              "biz-name": taxForm.bizName,
                              "onUpdate:bizName": _cache[10] || (_cache[10] = ($event: any) => ((taxForm.bizName) = $event)),
                              "biz-num": taxForm.bizNum,
                              "onUpdate:bizNum": _cache[11] || (_cache[11] = ($event: any) => ((taxForm.bizNum) = $event)),
                              email: taxForm.email,
                              "onUpdate:email": _cache[12] || (_cache[12] = ($event: any) => ((taxForm.email) = $event))
                            }, null, 8, ["biz-name", "biz-num", "email"]),
                            _createElementVNode("button", {
                              type: "submit",
                              class: "order-detail__claim-btn order-detail__claim-btn--primary",
                              disabled: taxRequesting.value
                            }, _toDisplayString(taxRequesting.value ? '요청 중…' : '발행 요청'), 9, _hoisted_90)
                          ], 32))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("aside", _hoisted_91, [
                _createElementVNode("div", {
                  class: _normalizeClass(["order-detail__account", { 'is-done': order.value.status === 'PAID' }])
                }, [
                  _createElementVNode("p", _hoisted_92, [
                    _createVNode(AppIcon, {
                      icon: order.value.payMethod === 'TOSS' ? 'mdi-credit-card-outline' : 'mdi-bank-outline',
                      size: 18
                    }, null, 8, ["icon"]),
                    _createTextVNode(" " + _toDisplayString(order.value.status === 'PAID'
                  ? '결제'
                  : order.value.payMethod === 'TOSS'
                    ? '카드 · 간편결제'
                    : '입금 계좌'), 1)
                  ]),
                  (order.value.status === 'PENDING' && order.value.payMethod === 'TOSS')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("p", _hoisted_93, [
                          _createTextVNode(_toDisplayString(_unref(formatPrice)(order.value.totalAmount)), 1),
                          _cache[57] || (_cache[57] = _createElementVNode("em", null, "원", -1))
                        ]),
                        _createElementVNode("p", _hoisted_94, _toDisplayString(payNotice.value), 1),
                        (tossEnabled.value)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "order-detail__notify",
                              disabled: payButtonDisabled.value,
                              onClick: onPayAction
                            }, _toDisplayString(payButtonLabel.value), 9, _hoisted_95))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (order.value.status === 'PENDING')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createElementVNode("p", _hoisted_96, [
                            _createTextVNode(_toDisplayString(_unref(formatPrice)(order.value.totalAmount)), 1),
                            _cache[58] || (_cache[58] = _createElementVNode("em", null, "원", -1)),
                            _createElementVNode("button", {
                              type: "button",
                              class: "order-detail__mini-copy",
                              onClick: copyAmount
                            }, _toDisplayString(copiedField.value === 'amount' ? '복사됨' : '복사'), 1)
                          ]),
                          _createElementVNode("dl", _hoisted_97, [
                            _createElementVNode("div", null, [
                              _cache[59] || (_cache[59] = _createElementVNode("dt", null, "은행", -1)),
                              _createElementVNode("dd", null, _toDisplayString(payment.value?.bankName), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[60] || (_cache[60] = _createElementVNode("dt", null, "계좌", -1)),
                              _createElementVNode("dd", null, [
                                _createTextVNode(_toDisplayString(payment.value?.account) + " ", 1),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "order-detail__mini-copy",
                                  onClick: copyAccount
                                }, _toDisplayString(copiedField.value === 'account' ? '복사됨' : '복사'), 1)
                              ])
                            ]),
                            _createElementVNode("div", null, [
                              _cache[61] || (_cache[61] = _createElementVNode("dt", null, "예금주", -1)),
                              _createElementVNode("dd", null, _toDisplayString(payment.value?.holder), 1)
                            ]),
                            _createElementVNode("div", null, [
                              _cache[62] || (_cache[62] = _createElementVNode("dt", null, "입금자명", -1)),
                              _createElementVNode("dd", null, [
                                _createTextVNode(_toDisplayString(order.value.depositor || order.value.receiver) + " ", 1),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "order-detail__mini-copy",
                                  onClick: copyDepositor
                                }, _toDisplayString(copiedField.value === 'depositor' ? '복사됨' : '복사'), 1)
                              ])
                            ])
                          ]),
                          (payment.value?.notice)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_98, _toDisplayString(payment.value.notice), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("button", {
                            type: "button",
                            class: _normalizeClass(["order-detail__notify", { 'is-done': Boolean(order.value.payNotifiedAt) }]),
                            disabled: notifying.value || Boolean(order.value.payNotifiedAt),
                            onClick: onNotifyPayment
                          }, [
                            _createVNode(AppIcon, {
                              icon: order.value.payNotifiedAt ? 'mdi-check-circle' : 'mdi-hand-coin-outline',
                              size: 20
                            }, null, 8, ["icon"]),
                            _createTextVNode(" " + _toDisplayString(order.value.payNotifiedAt
                    ? '입금 알림을 보냈습니다'
                    : notifying.value
                      ? '알리는 중…'
                      : '입금했어요'), 1)
                          ], 10, _hoisted_99),
                          _createElementVNode("p", _hoisted_100, _toDisplayString(order.value.payNotifiedAt
                    ? '운영팀이 통장을 확인하면 안내드립니다. 자동 결제가 아닙니다.'
                    : '버튼을 눌러도 자동 출금되지 않습니다. 직접 이체한 뒤 알려 주세요.'), 1)
                        ], 64))
                      : (order.value.status === 'PAID')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createElementVNode("p", _hoisted_101, [
                              _createVNode(AppIcon, {
                                icon: "mdi-check-circle",
                                size: 20
                              }),
                              _createTextVNode(" " + _toDisplayString(order.value.payMethod === 'TOSS' ? '결제가 완료되었습니다' : '입금이 확인되었습니다'), 1)
                            ]),
                            _createElementVNode("p", _hoisted_102, [
                              _createTextVNode(_toDisplayString(_unref(formatPrice)(order.value.totalAmount)), 1),
                              _cache[63] || (_cache[63] = _createElementVNode("em", null, "원", -1))
                            ]),
                            _createElementVNode("p", _hoisted_103, _toDisplayString(order.value.payMethod === 'TOSS'
                    ? '카드 · 간편결제로 받은 주문입니다.'
                    : '무통장 입금으로 받은 주문입니다.') + " 판매업체가 상품을 준비합니다. ", 1)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                            _cache[64] || (_cache[64] = _createElementVNode("p", { class: "order-detail__account-canceled" }, "취소된 주문입니다.", -1)),
                            (order.value.cancelReason)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_104, _toDisplayString(order.value.cancelReason), 1))
                              : _createCommentVNode("", true)
                          ], 64))
                ], 2),
                _createElementVNode("div", _hoisted_105, [
                  _cache[68] || (_cache[68] = _createElementVNode("p", { class: "order-detail__remote-title" }, "주문 메뉴", -1)),
                  (canPrintStatement.value)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        type: "button",
                        class: "order-detail__remote-btn is-primary",
                        onClick: onPrint
                      }, [
                        _createVNode(AppIcon, {
                          icon: "mdi-printer-outline",
                          size: 18
                        }),
                        _cache[65] || (_cache[65] = _createTextVNode(" 거래명세서 인쇄 ", -1))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("button", {
                    type: "button",
                    class: "order-detail__remote-btn",
                    disabled: reordering.value,
                    onClick: onReorder
                  }, [
                    _createVNode(AppIcon, {
                      icon: "mdi-cart-plus",
                      size: 18
                    }),
                    _createTextVNode(" " + _toDisplayString(reordering.value ? '담는 중…' : '같은 상품 다시 담기'), 1)
                  ], 8, _hoisted_106),
                  _createVNode(_component_router_link, {
                    to: _unref(MALL_ORDERS_PATH),
                    class: "order-detail__remote-btn"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(AppIcon, {
                        icon: "mdi-clipboard-list-outline",
                        size: 18
                      }),
                      _cache[66] || (_cache[66] = _createTextVNode(" 주문내역 전체보기 ", -1))
                    ]),
                    _: 1
                  }, 8, ["to"]),
                  (order.value.status === 'PENDING')
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        type: "button",
                        class: "order-detail__remote-btn is-danger",
                        disabled: canceling.value,
                        onClick: onCancel
                      }, [
                        _createVNode(AppIcon, {
                          icon: "mdi-close-circle-outline",
                          size: 18
                        }),
                        _cache[67] || (_cache[67] = _createTextVNode(" 주문 취소 ", -1))
                      ], 8, _hoisted_107))
                    : _createCommentVNode("", true)
                ])
              ])
            ])),
      (order.value && canPrintStatement.value)
        ? (_openBlock(), _createElementBlock("article", _hoisted_108, [
            _createElementVNode("header", _hoisted_109, [
              _createElementVNode("div", null, [
                _cache[69] || (_cache[69] = _createElementVNode("p", { class: "order-detail__statement-eyebrow" }, "함우리몰 거래명세서", -1)),
                _createElementVNode("h1", null, _toDisplayString(order.value.orgName || '기관명 미확인'), 1),
                _createElementVNode("p", _hoisted_110, [
                  _createTextVNode(" 주문번호 " + _toDisplayString(order.value.code) + " ", 1),
                  (order.value.poNumber)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" · 발주번호 " + _toDisplayString(order.value.poNumber), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("p", _hoisted_111, [
                  _createTextVNode(" 주문일시 " + _toDisplayString(formatDateTime(order.value.orderedAt)) + " ", 1),
                  (order.value.paidAt)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" · " + _toDisplayString(order.value.payMethod === 'TOSS' ? '결제확인' : '입금확인') + " " + _toDisplayString(formatDateTime(order.value.paidAt)), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("p", _hoisted_112, " 결제수단 " + _toDisplayString(order.value.payMethod === 'TOSS' ? (order.value.pgMethod || '카드·간편결제') : '계좌이체'), 1)
              ]),
              _createElementVNode("div", _hoisted_113, _toDisplayString(order.value.payMethod === 'TOSS' ? '결제확인' : '입금확인'), 1)
            ]),
            _createElementVNode("table", _hoisted_114, [
              _cache[70] || (_cache[70] = _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, "상품"),
                  _createElementVNode("th", { class: "is-num" }, "수량"),
                  _createElementVNode("th", { class: "is-num" }, "단가"),
                  _createElementVNode("th", { class: "is-num" }, "금액")
                ])
              ], -1)),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.value.items, (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: `stmt-${item.idx}`
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("strong", null, _toDisplayString(item.name), 1),
                      (item.option)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_115, "옵션 · " + _toDisplayString(item.option), 1))
                        : _createCommentVNode("", true),
                      (item.storeName)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_116, "판매 · " + _toDisplayString(item.storeName), 1))
                        : _createCommentVNode("", true),
                      (item.unit)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_117, _toDisplayString(item.unit), 1))
                        : _createCommentVNode("", true),
                      (frozenTerms(item))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_118, _toDisplayString(frozenTerms(item)), 1))
                        : _createCommentVNode("", true),
                      (item.status === 'CANCELED')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_119, "취소 · 환불 " + _toDisplayString(_unref(formatPrice)(item.refundAmount || 0)) + "원", 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", _hoisted_120, _toDisplayString(item.qty), 1),
                    _createElementVNode("td", _hoisted_121, _toDisplayString(_unref(formatPrice)(item.price)) + "원", 1),
                    _createElementVNode("td", _hoisted_122, _toDisplayString(_unref(formatPrice)(item.amount)) + "원", 1)
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("dl", _hoisted_123, [
              _createElementVNode("div", null, [
                _cache[71] || (_cache[71] = _createElementVNode("dt", null, "상품금액", -1)),
                _createElementVNode("dd", null, _toDisplayString(_unref(formatPrice)(order.value.itemAmount)) + "원", 1)
              ]),
              _createElementVNode("div", null, [
                _cache[72] || (_cache[72] = _createElementVNode("dt", null, "주문 배송비", -1)),
                _createElementVNode("dd", null, _toDisplayString(_unref(formatShippingFeeAmount)(order.value.shippingFee)), 1)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass({ 'is-total': !refundRelation.value.refunded })
              }, [
                _createElementVNode("dt", null, _toDisplayString(refundRelation.value.refunded ? '결제 금액' : '합계'), 1),
                _createElementVNode("dd", null, _toDisplayString(_unref(formatPrice)(order.value.totalAmount)) + "원", 1)
              ], 2),
              (refundRelation.value.refunded)
                ? (_openBlock(), _createElementBlock("div", _hoisted_124, [
                    _cache[73] || (_cache[73] = _createElementVNode("dt", null, "환불 완료", -1)),
                    _createElementVNode("dd", null, "-" + _toDisplayString(_unref(formatPrice)(refundRelation.value.refunded)) + "원", 1)
                  ]))
                : _createCommentVNode("", true),
              (refundRelation.value.refundPending)
                ? (_openBlock(), _createElementBlock("div", _hoisted_125, [
                    _cache[74] || (_cache[74] = _createElementVNode("dt", null, "환불 대기", -1)),
                    _createElementVNode("dd", null, _toDisplayString(_unref(formatPrice)(refundRelation.value.refundPending)) + "원", 1)
                  ]))
                : _createCommentVNode("", true),
              (refundRelation.value.refunded)
                ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
                    _cache[75] || (_cache[75] = _createElementVNode("dt", null, "결제 잔액", -1)),
                    _createElementVNode("dd", null, _toDisplayString(_unref(formatPrice)(refundRelation.value.balance)) + "원", 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("section", _hoisted_127, [
              _cache[78] || (_cache[78] = _createElementVNode("h2", null, "배송지", -1)),
              _createElementVNode("p", null, [
                _createTextVNode(_toDisplayString(order.value.receiver) + " · " + _toDisplayString(order.value.phone), 1),
                _cache[77] || (_cache[77] = _createElementVNode("br", null, null, -1)),
                _createTextVNode(" " + _toDisplayString(order.value.address) + " " + _toDisplayString(order.value.addressDetail) + " ", 1),
                (order.value.memo)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _cache[76] || (_cache[76] = _createElementVNode("br", null, null, -1)),
                      _createTextVNode("요청사항 · " + _toDisplayString(order.value.memo), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ]),
            (hasTaxRecord.value)
              ? (_openBlock(), _createElementBlock("section", _hoisted_128, [
                  _cache[80] || (_cache[80] = _createElementVNode("h2", null, "세금계산서", -1)),
                  _createElementVNode("p", null, [
                    _createTextVNode(_toDisplayString(taxStatusLabel.value) + " ", 1),
                    (order.value.bizName)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(" · " + _toDisplayString(order.value.bizName), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    (order.value.bizNum)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" · " + _toDisplayString(_unref(formatBizNumber)(order.value.bizNum)), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    (order.value.taxEmail)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                          _cache[79] || (_cache[79] = _createElementVNode("br", null, null, -1)),
                          _createTextVNode("수신 · " + _toDisplayString(order.value.taxEmail), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("p", _hoisted_129, " 본 거래명세서는 " + _toDisplayString(order.value.payMethod === 'TOSS' ? '결제 확인된' : '입금 확인된') + " 주문 기준입니다. 재고·배송 상태는 주문 상세에서 확인해 주세요. ", 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    (payHold.value)
      ? (_openBlock(), _createBlock(MallPayHold, {
          key: 0,
          onClose: closePayHold,
          onRefresh: refreshPay
        }))
      : _createCommentVNode("", true),
    (trackTarget.value)
      ? (_openBlock(), _createBlock(MallTrackingModal, {
          key: 1,
          "item-idx": trackTarget.value.idx,
          courier: trackTarget.value.courier,
          invoice: trackTarget.value.invoice,
          "product-name": trackTarget.value.name,
          "order-code": trackTarget.value.orderCode,
          onClose: onCloseTracking
        }, null, 8, ["item-idx", "courier", "invoice", "product-name", "order-code"]))
      : _createCommentVNode("", true)
  ]))
}
}

})